import React, { memo } from "react";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import {
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledBadge } from "../style";
import { useGlobalContext } from "context/GlobalContext";
import { fetchTaskLogsApi } from "API/apis/task/taskLogs";
import { message } from "constants/responses/message";
import { Box } from "@mui/system";
import { style } from "../style";
import dayjs from "configs/dayjs.config";

import { dateTimeFormat } from "constants/componentsConstants";
import { SeeMore } from "components/Text/SeeMore";

export const TaskLogs = ({
  id,
  updateCount,
  openLogModal,
  setOpenLogModal,
  logList,
  setLogList,
}) => {
  const { setError, setIsLoading } = useGlobalContext();

  const handleClose = () => {
    setLogList([]);
    setOpenLogModal(false);
  };

  const handleLogButtonClick = async (e, id) => {
    try {
      setIsLoading(true);
      const { data, status } = await fetchTaskLogsApi(id);
      if (status !== 200) {
        throw new Error(message.error.generalFailure);
      }
      setLogList(data);
      setOpenLogModal(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <IconButton
        onClick={(event) => handleLogButtonClick(event, id)}
        size="small"
      >
        <StyledBadge
          badgeContent={isNaN(updateCount) ? 0 : Number(updateCount)}
          color="primary"
        >
          <AccessTimeFilledIcon />
        </StyledBadge>
      </IconButton>
      <Modal
        open={openLogModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="right">Timestamp</TableCell>
                  <TableCell>Task</TableCell>
                  <TableCell align="right">Assigned To</TableCell>
                  <TableCell align="right">Deadline</TableCell>
                  <TableCell align="right">Alert Before</TableCell>
                  <TableCell align="right">Status</TableCell>
                  <TableCell align="right">Completed</TableCell>
                  <TableCell align="right">Acknowledged</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logList?.length > 0 &&
                  logList.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="right">
                        {dayjs(row.timestamp).format(dateTimeFormat.date)}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <SeeMore text={row.taskDetails} />
                      </TableCell>
                      <TableCell align="right">
                        {row.taskTo.label || "-"}
                        <br />
                        {row.taskToOn
                          ? "[" +
                            dayjs(row.taskToOn).format(dateTimeFormat.date) +
                            "]"
                          : "-"}
                      </TableCell>
                      <TableCell align="right">
                        {dayjs(row.deadline).format(dateTimeFormat.date)}
                      </TableCell>
                      <TableCell align="right">{row.alertBeforeDays}</TableCell>
                      <TableCell align="right">
                        {row.acceptanceStatus}
                        <br />
                        {row.acceptanceOn
                          ? "[" +
                            dayjs(row.acceptanceOn).format(
                              dateTimeFormat.date
                            ) +
                            "]"
                          : "-"}
                      </TableCell>
                      <TableCell align="right">
                        {row.doneStatus ? "Done" : "-"} <br />
                        {row.doneOn
                          ? "[" +
                            dayjs(row.doneOn).format(dateTimeFormat.date) +
                            "]"
                          : "-"}
                      </TableCell>
                      <TableCell align="right">
                        {row.acknowledgeStatus ? "ACKD" : "-"}
                        <br />
                        {row.acknowledgeOn
                          ? "[" +
                            dayjs(row.acknowledgeOn).format(
                              dateTimeFormat.date
                            ) +
                            "]"
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </>
  );
};
